/**
 * 連続記録カードコンポーネント
 *
 * 各習慣のストリーク（連続達成日数）を表示する。
 * 火のアイコンで視覚的にモチベーションを高める。
 *
 * Rails で言えば:
 * - app/views/dashboard/_streak_card.html.erb に相当
 *
 * @example
 * <StreakCard streaks={streaks} />
 */

import { Flame } from 'lucide-react'
import type { Streak } from '@/types'

interface StreakCardProps {
  /** ストリーク情報のリスト */
  streaks: Streak[]
}

export function StreakCard({ streaks }: StreakCardProps) {
  return (
    <div className="bg-card border-border rounded-xl border p-4 sm:p-5">
      <h2 className="text-foreground mb-4 flex items-center gap-2 font-semibold">
        <Flame className="h-5 w-5 text-orange-500" />
        連続記録
      </h2>

      {streaks.length > 0 ? (
        <div className="space-y-3">
          {streaks.map((streak) => (
            <div key={streak.id} className="flex items-center gap-3">
              {/* 習慣のカラーインジケーター */}
              <div
                className="h-8 w-2 rounded-full"
                style={{ backgroundColor: streak.color || '#3b82f6' }}
              />

              {/* 習慣名とストリーク情報 */}
              <div className="min-w-0 flex-1">
                <div className="truncate text-sm font-medium">
                  {streak.name}
                </div>
                <div className="text-muted-foreground text-xs">
                  {streak.streak > 0 ? `${streak.streak}日連続` : '記録なし'}
                </div>
              </div>

              {/* ストリークバッジ（連続日数がある場合のみ表示） */}
              {streak.streak > 0 && (
                <div className="flex items-center gap-1 text-orange-500">
                  <Flame className="h-4 w-4" />
                  <span className="text-sm font-bold">{streak.streak}</span>
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <p className="text-muted-foreground py-4 text-center text-sm">
          習慣を追加すると連続記録が表示されます
        </p>
      )}
    </div>
  )
}
